import { useEffect } from 'react';

export type RefSections = (HTMLDivElement | null)[];

type Props = {
  setStep: (step: number) => void;
  sections: RefSections | null;
  initProps?: IntersectionObserverInit;
};

export const useIntersectionObserver = ({ setStep, sections, initProps }: Props) => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visibleSections = entries
          .filter((entry) => entry.isIntersecting)
          .map((entry) => ({
            index: Number((entry.target as HTMLElement).dataset.index),
            top: entry.boundingClientRect.top,
          }))
          .sort((a, b) => a.top - b.top);

        if (visibleSections.length > 0) {
          const firstVisible = visibleSections[0];
          setStep(firstVisible.index);
        }
      },
      {
        root: null,
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0,
        ...initProps,
      },
    );

    sections?.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, [sections, setStep]);
};
